var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.25a.75.75 0 0 1 .75.75v4.145l.031.013L10.97 3.97a.75.75 0 1 1 1.06 1.06L9.842 7.22l.013.031H14a.75.75 0 0 1 0 1.5H9.855a2.01 2.01 0 0 1-.013.031l2.188 2.189a.75.75 0 1 1-1.06 1.06L8.78 9.842a1.97 1.97 0 0 1-.031.013V14a.75.75 0 0 1-1.5 0V9.855a1.97 1.97 0 0 1-.031-.013L5.03 12.03a.75.75 0 0 1-1.06-1.06l2.188-2.19a2.01 2.01 0 0 1-.013-.031H2a.75.75 0 0 1 0-1.5h4.145l.013-.031L3.97 5.03a.75.75 0 0 1 1.06-1.06l2.19 2.188.031-.013V2A.75.75 0 0 1 8 1.25z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsight);
export default ForwardRef;